import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ButtonLink } from '../../styled/components/Button';
import { modalsSlice } from '../../features/modals/modalsSlice';

export interface EmptyCacheButtonProps {
  onClick?: () => void;
}

const EmptyCacheButton: React.FC<EmptyCacheButtonProps> = (props) => {
  const dispatch = useDispatch();
  const { onClick } = props;

  return (
    <ButtonLink
      onClick={() => {
        if (onClick) {
          onClick();
        } else {
          dispatch(modalsSlice.actions.setResetAndReloadModal(true));
        }
      }}
      className="red"
    >
      <FormattedMessage id="buttons.emptyLocalCache" />
    </ButtonLink>
  );
};

export default EmptyCacheButton;
